function getConfigCompoment () { return 'YMConfigCompoment' }
function getStandardAttributes () {
  return []
}

export default {
  hasSync: false,
  hasExecutions: true,
  hasItemSync: false,
  canManageAttributes: true,
  getConfigCompoment,
  getStandardAttributes
}
